import { css } from '@emotion/react';
import { fontFamily } from '@atlaskit/theme/constants';
import { N900, N200 } from '@atlaskit/theme/colors';
// ED-51: This is to increase the specificity of the input styles
// to override the default input styles applied by Trello
const INCREASE_SPECIFICITY = '&&';

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
export const inputStyles = css`
  ${INCREASE_SPECIFICITY} {
    border: none;
    color: ${`var(--ds-text-accent-gray-bolder, ${N900})`};
    background: none;
    font-size: 14px;
    font-family: ${fontFamily()};
    &:focus {
      outline: none;
    }
    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    &::placeholder {
      color: ${`var(--ds-text-subtlest, ${N200})`};
    }
    width: 100%;
    padding: ${"var(--ds-space-025, 2px)"} 0px;
    resize: none;
    overflow: hidden;
    line-height: inherit;
  }
`;

// CSS applied for autogrowing textarea.
// Refer to https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/ for more info
export const multilineInputWrapperStyles = css`
  display: grid;
  position: relative;
  flex: 1;
  ::after {
    content: attr(data-replicated-value) ' ';
    white-space: pre-wrap;
    visibility: hidden;
    ${inputStyles}
  }
  > textarea,
  ::after {
    ${inputStyles}

    /* Place on top of each other */
    grid-area: 1 / 1 / 2 / 2;
  }
`;
export const hiddenDivStyles = css`
  position: absolute;
  visibility: hidden;
  bottom: 0;
  ::after {
    content: attr(data-replicated-value) ' ';
    white-space: pre-wrap;
    visibility: hidden;
    ${inputStyles}
  }
`;